import React, { useContext } from 'react'
import { useQRCode } from 'next-qrcode'
import styles from './ModalPreparation.module.scss'
import ChangeModal from './changeModal'
import { IdentifyModalValue } from './StartModal'
import ModalButton from 'spa/member/components/ModalButton'

const ModalPreparation: React.FC<ChangeModal> = (props) => {
  const context = useContext(IdentifyModalValue)
  const { SVG } = useQRCode()
  const isPc = !navigator.userAgent.match(/iPhone|Android.+Mobile|iPad/)

  const handleClick = () => window.open(context.shootingUrl, '_blank', 'noreferrer')

  const reload = () => {
    location.reload()
  }

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modalContainer} js-modal-container`}>
        <div className={styles.preparationImage}></div>
        <div className={styles.sectionTitle}><p><span>申請準備</span>が整いました</p></div>
        <div className={styles.sectionAttention}>
          <p>画面を閉じる前に必ず{isPc ? '「QRコードの読み取り」': '申請'}を行なってください。</p>
        </div>
        <div className={styles.sectionText}>
          <p>本人確認の申請に必要な書類は以下の通りです。</p>
          {isPc && <p>書類をご準備のうえ、以下のQRコードより申請を開始してください。</p>}
          <p>結果は1営業日後に画面上のステータスにて確認できます。</p>
          <p className={`${styles.sectionAttention} small`}>住所記載がないパスポートでは、本人確認ができないため他書類をご用意ください</p>
        </div>
        <div className={styles.sectionCallout}>
          <p>{context.requiredDocument}</p>
        </div>
        {isPc && <div className={styles.identifyVerificationQrcode}>
          <SVG
            text={context.shootingUrl}
            options={{
              margin: 0,
              width: 200,
              color: {
                dark: '#000000',
                light: '#ffffff',
              },
            }}
          />
        </div>}
        <div className={styles.sectionBtn}>
          {isPc ?
            <ModalButton buttonType='NEXT' onClick={reload}>閉じる</ModalButton> :
            <ModalButton buttonType='NEXT' onClick={handleClick}>申請を開始</ModalButton>
          }
        </div>
        {!isPc && <div className={styles.sectionBtnClose}>
          <button onClick={() => props.changeModal('')} className={styles.btnItemClose}>キャンセル</button>
        </div>}
      </div>
    </div>
  )
}
export default ModalPreparation
